import { createSelectorHook } from "react-redux";
import { store } from "../store";
import { useArmazemGeral } from "../store/ducks/application/ArmazemGeral/useArmazemGeral";

/**
 * Seletor do redux tipado para o estado geral do app
 * @deprecated Use os hooks de estado de cada reducer já que o seletor não garante a tipagem correta dos estados
 * @see {@link useArmazemGeral}
 * @type {ReturnType<typeof createSelectorHook<ReturnType<typeof store.getState>>>}
 */
export const useTypedSelector = createSelectorHook();
